import type { FunctionComponent } from "react";

import PhoneNotification from "./phone_notification.png";
import Slide1 from "./slide1.svg?url";
import Slide2 from "./slide2.svg?url";
import Slide3 from "./slide3.svg?url";
import {
  Container,
  Image,
  ImageContainer,
  Point,
  Points,
  Slide,
  SlideContainer,
  TextWrapper,
  Title,
} from "./styles";

export const AddingTopicsAndAuthors: FunctionComponent = () => (
  <Container>
    <TextWrapper>
      <Title>Adding topics & authors </Title>
      <Points>
        <Point>Follow your favourite authors and columnists</Point>
        <Point>Keep up to date with stories from your favourite topics</Point>
        <Point>Get personalised alerts to make sure you never miss a story</Point>
      </Points>
    </TextWrapper>
    <ImageContainer>
      <Image alt="myNews" src={PhoneNotification.src} />
      <SlideContainer>
        <Slide $bgImage={Slide1} />
        <Slide $bgImage={Slide2} />
        <Slide $bgImage={Slide3} />
      </SlideContainer>
    </ImageContainer>
  </Container>
);

AddingTopicsAndAuthors.displayName = "AddingTopicsAndAuthors";
